import Message from "./Message";
import NegotiationController from '../controllers/NegotiationController';

export default (function (w, d) {
    'use strict';

    function ProductOffer(is_product = true) {
        if (is_product) {
            this.form = d.querySelector('.product-offer-form');
            this.formSubmitButton = this.form ? this.form.querySelector('.submit-product-offer') : null;
        }

        this.is_product = is_product;
        this.userLoggedIn = window.userLoggedIn;

        const negotiation_popup = d.querySelector('.negotiation-popup');
        this.popup = negotiation_popup ? negotiation_popup.parentElement : null;
        this.popupCloseBtn = negotiation_popup ? this.popup.querySelector('.close') : null;
        this.popupForm = negotiation_popup ? this.popup.querySelector('.offer-form') : null;
        this.popupFormSubmitBtn = negotiation_popup ? this.popup.querySelector('.submit-offer') : null;

        this.init();
    }

    ProductOffer.prototype.init = function () {
        this.initFormSubmitBtn();
        this.initPopupActions();
    }

    ProductOffer.prototype.initFormSubmitBtn = function () {
        if (this.is_product) {
            if (this.formSubmitButton) {
                this.formSubmitButton.addEventListener('click', (e) => {
                    e.preventDefault();

                    if (this.userLoggedIn) {
                        this.submitFormData(this.form);
                        return;
                    }

                    const productIdValue = this.form.querySelector('input[name="product_id"]').value;
                    const productPriceValue = this.form.querySelector('input[name="product_price"]').value;
                    const priceValue = this.form.querySelector('input[name="price"]').value;

                    this.initPopupInputs(productIdValue, productPriceValue, priceValue);
                });
            } else {
                new NegotiationController();
            }
        } else {
            $(d).on('click', '.submit-product-card-offer', (e) => {
                const data = $(e.target).data();
                const parent_data = $(e.target).parent().data();

                const productIdValue = data.product_id || parent_data.product_id;
                const productPriceValue = data.price || parent_data.price;
                const priceValue = data.price || parent_data.price;

                this.initPopupInputs(productIdValue, productPriceValue, priceValue);
            });
        }
    }

    ProductOffer.prototype.initPopupInputs = function (productIdValue, productPriceValue, priceValue) {
        this.popup.querySelector('input[name="product_id"]').value = productIdValue;
        this.popup.querySelector('input[name="product_price"]').value = productPriceValue;
        this.popup.querySelector('input[name="price"]').value = priceValue;

        this.togglePopup();
    }

    ProductOffer.prototype.initPopupActions = function () {
        $(this.popupCloseBtn).off('click').on('click', (e) => {
            e.preventDefault();

            this.togglePopup();
        });

        $(this.popupFormSubmitBtn).off('click').on('click', (e) => {
            e.preventDefault();

            this.submitFormData(this.popupForm);
        });
    }

    ProductOffer.prototype.togglePopup = function () {
        this.popup.classList.toggle('hidden');
    }

    ProductOffer.prototype.submitFormData = function (form) {
        const formData = $(form).serialize();
        const action = form.action;

        const data = JSON.parse('{"' + formData.replace(/&/g, '","').replace(/=/g, '":"') + '"}', (key, value) => {
            return key === '' ? value : decodeURIComponent(value);
        });

        if (data.price * 1 >= data.product_price * 1) {
            new Message(window.errorMessages.big_offered_price, 'error');
            return;
        }

        $.ajax({
            url: action,
            method: 'POST',
            data: formData,
            success: function (response) {
                if (response.status === 'error') {
                    new Message(response.message, 'error');
                    return;
                }

                new Message(response.message, 'success');

                if (response.status === 'success') {
                    $('.negotiation-popup').parent().addClass('hidden');
                }
            },
        });
    }

    return ProductOffer;
}(window, document));
